<template>
    <div></div>
</template>

<script setup>
import { getToken, cacheGetAppId, cacheGetTargetUrl, cacheRemoveAppId, cacheRemoveTargetUrl, getUserInfo } from '@/utils/common';
import { onMounted } from 'vue';
import { getAuthTokenByAppId } from '@/api/auth';
import { ElMessage } from 'element-plus';


const wrongMsg = (text) => {
    ElMessage({
        message: text,
        type: 'warning'
    })
}

const initData = () =>{
    const token = getToken()
    const userInfo = getUserInfo()
    if(token){
        if(!userInfo || !userInfo.name){
            wrongMsg('请完善信息后再试')
            return;
        }
        const appId = cacheGetAppId()
        const targetUrl = cacheGetTargetUrl();
        if(appId && targetUrl){
            getAuthTokenByAppId({appId: appId}).then(response => {
                const res = response.data;
                if(res.code == 200){
                    cacheRemoveAppId();
                    cacheRemoveTargetUrl();
                    window.location.href = targetUrl + res.data;
                }else{
                    wrongMsg(res.msg);
                    return;
                }
            })
        }else{
            wrongMsg('参数错误')
            return;
        }
    }else{
        wrongMsg('请登录后再试')
        return;
    }
}


onMounted(()=>{
    initData();
})



</script>